(function () {

    angular.module('FotocApp')

        .service('$canvasService', ['$rootScope', 'CONSTANTS', '$editorService', '$timeout', '$lang', '$tutorialService', function ($rootScope, CONSTANTS, $editorService, $timeout, $lang, $tutorialService) {

            var self = this;
            var stage;
            var canvas = document.getElementById('canvas-editor');
            var preloadImagesAmbients = new createjs.LoadQueue(false);

            var colorContainer = null;
            var ambientsContainer = null;
            var array_elements_transformables = [];
            var mask_container = null;
            var mask_container_group = null;
            var borders_masks = null;
            var back_masks = null;
            var composition = null;
            var borders_3d_frames = null;
            var center_composition = null;
            var marco_mat = null;         // LOCAL DEV: passepartout (mat) del modo marco
            var marco_mould = null;       // LOCAL DEV: moldura del modo marco
            var marco_frame_color = null; // color de moldura elegido (por el selector)
            var hit_area_tiles_gorup = null;
            var measuresContainer = null;
            var _composition_scale = 1;
            //var fpsLabel;
            var current_ambiend = null;
            var in_upload_tile_view = true;
            this.isLoading = false;
            var active_to_click_upload_tiles = true;
            var last_click = new Date().getTime();
            var drag_offsetClick = 0;
            var drag_center_composition_last_x = 0;
            var drag_startTime = 0;
            var enable_to_drag = false;

            $rootScope.$canvasService = this;

            this.init = function () {

                stage = new createjs.Stage(canvas);

                stage.snapToPixelsEnabled = true;
                createjs.framerate = 60;
                createjs.Ticker.timingMode = createjs.Ticker.RAF;

                stage.enableMouseOver(5);
                createjs.Touch.enable(stage, false, true);
                stage.preventSelection = false;

                colorContainer = new createjs.Container();
                stage.addChild(colorContainer);

                composition = new createjs.Container();
                composition.scaleX = composition.scaleY = .9
                composition.x = CONSTANTS.CANVAS_WIDTH / 2
                composition.y = CONSTANTS.CANVAS_HEIGHT / 2
                stage.addChild(composition);

                ambientsContainer = new createjs.Container();
                stage.addChild(ambientsContainer);

                measuresContainer = new createjs.Container();
                measuresContainer.alpha = 0;
                measuresContainer.mouseEnabled = false;
                stage.addChild(measuresContainer);

                addCompositionAssets();
                addListeners();

                $rootScope.$watch('$editorService.ui.editingItem', function (a, b) {
                    showBorderEditingitem();
                    validateViewBorderMask();

                    if ($editorService.ui.compositionsAsGroup) {

                        setInViewEditingFrame()

                        if ($editorService.ui.editingItem === -1) {
                            $editorService.ui.toolOpen = 'images';
                        }
                    }
                });


                if ($editorService.ui.compositionsAsGroup) {

                    $rootScope.$watchCollection('$editorService.data.images', function (a, b) {

                        createTilesFrame(false);

                        removeAllTilesNotInUse();

                        $editorService.data.images.forEach(function (image, index) {
                            var color = image.frameColor || $editorService.ui.lastFrameColorSelected

                            createTilesFrame(image, color, index)
                        });

                        reorderTilesFrame();

                        $editorService.setObjectPrice();
                    })

                }


                $rootScope.$watch('$editorService.data.layout_size', function (a, b) {
                    setInview()
                    self.setLayout(false);
                    transformCopositionForAmbient();
                    setMeasuresVisibility();

                })

                $rootScope.$watch('$editorService.ui.view', function (a, b) {
                    setView($editorService.ui.view.type, $editorService.ui.view.id);
                    setMeasuresVisibility();
                    setInview()
                })

                $rootScope.$watch('$editorService.ui.bgColor', function (a, b) {

                    var shapeColor = new createjs.Shape();
                    shapeColor.graphics.beginFill($editorService.ui.bgColor).drawRect(0, 0, CONSTANTS.CANVAS_WIDTH, CONSTANTS.CANVAS_HEIGHT);
                    shapeColor.alpha = 0;
                    colorContainer.addChild(shapeColor);
                    createjs.Tween.get(shapeColor).to({ alpha: 1 }, 500)
                })

                $rootScope.$watch('$editorService.ui.showMeasures', function (a, b) {

                    transformCopositionForAmbient();
                    setMeasuresVisibility();

                    if ($editorService.ui.showMeasures) {
                        $tutorialService.show('size');
                    }

                });

                $rootScope.$watch('$editorService.ui.toolOpen', function (a, b) {


                    if ($editorService.ui.toolOpen == 'transform') {

                        composition.cursor = 'move'

                        for (var i = 0; i < array_elements_transformables.length; i++) {
                            if (array_elements_transformables[i].children.length > 0) {
                                array_elements_transformables[i].mouseEnabled = true
                            }
                        }

                        setInview();

                        if ($editorService.ui.compositionsAsGroup) {
                            toogleActiveSliderTiles(true)
                        }

                    } else {

                        composition.cursor = 'default'

                        for (var i = 0; i < array_elements_transformables.length; i++) {
                            if (array_elements_transformables[i].children.length > 0) {
                                array_elements_transformables[i].mouseEnabled = false;
                            }
                        }

                        if ($editorService.ui.compositionsAsGroup) {
                            toogleActiveSliderTiles(false)
                        }
                    }

                    validateViewBorderMask()
                });

                /*
                fpsLabel = new createjs.Text("fps:", "24px Verdana", "red");
                fpsLabel.x = 10;
                fpsLabel.y = CONSTANTS.CANVAS_HEIGHT - 40;
                stage.addChild(fpsLabel);

                var version_txt = new createjs.Text("fps:", "24px Verdana", "green");
                version_txt.x = 130;
                version_txt.y = CONSTANTS.CANVAS_HEIGHT - 40;
                version_txt.text = 'version: ' + CONSTANTS.VERSION
                stage.addChild(version_txt);
                */

            };

            function addListeners() {


                center_composition.addEventListener("dblclick", handle_dblclick_frames)

                // ojo este bloque puede que sea solo valido para FOTOC
                if (!$editorService.ui.compositionsAsGroup) {
                    center_composition.addEventListener("mousedown", function (e) {
                        var b = $editorService.data.group === 1 ? 0 : e.target.parent.name;
                        handleSelectBound(e, b)
                    })

                }

                if ($editorService.ui.compositionsAsGroup) {
                    stage.addEventListener("mousedown", handleCenterComposition_mousedown)
                    stage.addEventListener("pressmove", handleCenterComposition_pressmove)
                    stage.addEventListener("pressup", handleCenterComposition_pressup, false)
                }

                preloadImagesAmbients.addEventListener("fileload", handleFileCompleteImageAmbient);
                preloadImagesAmbients.addEventListener("progress", handleFileProgressImageAmbient);

                self.stopTick()
                self.startTick()

                stage.addEventListener("pressup", updateSliders);

            }

            function getArrayOfAllUuidTiles() {

                return $editorService.data.images.map(function (item) {
                    return item.data.uuid;
                })

            }

            function removeAllTilesNotInUse() {

                var numChildrens = center_composition.numChildren;
                var arrayUuids = getArrayOfAllUuidTiles();

                var array_tiles_to_delete = [];

                for (var i = (numChildrens - 1); i > 0; i--) {

                    var name = center_composition.getChildAt(i).name;
                    if (name == 'hit' || name == 'uploadTile') continue;

                    if (arrayUuids.indexOf(center_composition.getChildAt(i).name) === -1) {
                        array_tiles_to_delete.push(center_composition.getChildAt(i))
                    }
                }
                array_tiles_to_delete.forEach(function (t) {
                    center_composition.removeChild(t)
                });

            }

            function mozaicTiles($cantPerRow) {


                var inRow = 0;
                var inColumn = 0;
                var cantPerRow = $cantPerRow;


                $editorService.data.images.forEach(function (image) {

                    var tile = center_composition.getChildByName(image.data.uuid);


                    tile.x = 1100 * inColumn
                    tile.y = 1100 * inRow


                    inColumn++;

                    if ($cantPerRow !== false) {
                        if (inColumn == cantPerRow) {
                            inRow++
                            inColumn = 0;
                        }
                    }


                });

            }

            function reorderTilesFrame() {

                var bulce = 0;
                $editorService.data.images.forEach(function (image) {

                    var tile = center_composition.getChildByName(image.data.uuid);
                    tile.x = 1100 * bulce++;

                    var transformable = tile.getChildByName('transformable');


                    if (image.position.x) {
                        transformable.x = image.position.x;
                        transformable.y = image.position.y;
                        transformable.scaleX = image.position.scaleX;
                        transformable.scaleY = image.position.scaleY;
                        transformable.rotation = image.position.rotation;
                    }


                });

                var upload = center_composition.getChildByName('uploadTile');
                upload.x = 1100 * bulce;

                hit_area_tiles_gorup.graphics.drawRect(0, 0, $editorService.data.images.length * 1100 + 1100, 1100)

            }

            function toogleActiveSliderTiles($bool) {


                $editorService.data.images.forEach(function (image) {

                    center_composition.getChildByName(image.data.uuid).getChildByName('transformable').mouseEnabled = $bool;

                })

            }

            function drawUploadTile(container) {

                var shape = new createjs.Shape();
                shape.graphics.setStrokeStyle(10).beginStroke("#fff").setStrokeDash([30, 30], 1);
                shape.graphics.drawRect(5, 5, 990, 990);
                container.addChild(shape);

                var image = new createjs.Bitmap(FOTOCEDITOR_EDITOR_ASSETS + 'emptyTile_' + window.lang + '.png?v=1');
                image.mouseEnabled = false;
                container.addChild(image);


            }

            function createTilesFrame(image, color, index) {

                try {

                    if (center_composition.getChildByName(image === false ? 'uploadTile' : image.data.uuid)) {

                        if (image !== false) {
                            // la imagen que itene es igual a la filtrada ?
                            if (image.urlWithFilter != center_composition.getChildByName(image.data.uuid).getChildByName('transformable').pathImage) {

                                loadImageOnTile(center_composition.getChildByName(image.data.uuid), image.urlWithFilter, index);


                            }

                        }

                        if (image) {
                            var tile = center_composition.getChildByName(image.data.uuid);
                            drawFrame3d(tile.getChildByName('frame'), color);
                            validateBleeding(tile);
                        }


                        return;
                    }
                } catch (e) {
                    console.warn(e);
                }

                var bounds = [0, 0, 1000, 1000];

                var container = new createjs.Container();
                container.name = image === false ? 'uploadTile' : image.data.uuid;


                var bg = makeShapePoligonPerimeter(bounds);
                container.addChild(bg);

                var transformable = new com.firsara.display.TransformClip();
                transformable.x = 500;
                transformable.y = 500;
                transformable.mouseEnabled = false;
                transformable.name = 'transformable';
                container.addChild(transformable);

                var shape = makeShapePoligonPerimeter(bounds);


                if (image === false) {

                    drawUploadTile(container);

                    container.addEventListener("pressup", function (e) {
                        if (active_to_click_upload_tiles) {
                            setTimeout(function () {
                                $editorService.uploadCare.value(null);
                                $editorService.uploadCare.openDialog();
                            }, 500);

                        }
                    });


                } else {
                    loadImageOnTile(container, image.urlWithFilter, index);
                }


                transformable.mask = shape;

                center_composition.addChild(container);

                var frameContainer = new createjs.Container();
                frameContainer.name = 'frame';
                container.addChild(frameContainer)


                drawFrame3d(frameContainer, color);

                //imagen para tiles
                var shadow3d = new createjs.Bitmap(FOTOCEDITOR_EDITOR_ASSETS + 'tile_3d.png');
                shadow3d.mouseEnabled = false;
                shadow3d.x = -0;
                shadow3d.y = -0;
                container.addChild(shadow3d);
                shadow3d.mask = shape;

                return container;


            }

            function loadImageOnTile($tileDisplayObject, imageUrl, index) {

                var preloadImages = new createjs.LoadQueue(true, "", true);
                var transformable = $tileDisplayObject.getChildByName('transformable');
                preloadImages.addEventListener("fileload", function (event) {
                    var image = new createjs.Bitmap(event.result);
                    image.tickEnabled = false;

                    var trasform_bitmap = adjustImageInBound(image, image.image.width, image.image.height, -1, [0, 0, 1000, 1000])

                    try {
                        transformable.removeChildAt(1);
                        transformable.removeChildAt(0)
                    } catch (e) {
                        console.warn(e);
                    }
                    transformable.pathImage = imageUrl;
                    transformable.addChildAt(image, 0);
                    self.isLoading = false;

                    // set postion
                    var w_px = 0;
                    if (transformable.getChildAt(0)) {
                        w_px = transformable.getChildAt(0).width * transformable.scaleX
                    }
                    var h_px = 0;
                    if (transformable.getChildAt(0)) {
                        h_px = transformable.getChildAt(0).height * transformable.scaleY
                    }


                    $editorService.data.images[index].position = {

                        x: transformable.x,
                        y: transformable.y,
                        scaleX: transformable.scaleX,
                        scaleY: transformable.scaleY,
                        rotation: transformable.rotation,
                        width_px: w_px,
                        height_px: h_px,
                        width_cm: convertPixelesToCm(w_px),
                        height_cm: convertPixelesToCm(h_px)
                    }


                    $rootScope.$apply();

                }
                );

                preloadImages.addEventListener("progress", function () {
                    handleFileProgressImageTile()
                });
                preloadImages.addEventListener("fileprogress", function () {
                    handleFileProgressImageTile()
                });


                preloadImages.loadFile({
                    src: $editorService.getProxyImageUrl(imageUrl),
                    type: createjs.Types.IMAGE,
                    'resetTransformale': true,
                    'transformable': transformable,
                    'refillOthers': false,
                    uuid: $tileDisplayObject.name
                });


            }

            function setInViewEditingFrame() {

                var x = -($editorService.ui.editingItem * 1100) - 500
                if ($editorService.ui.editingItem === -1) {

                    x = -($editorService.data.images.length * 1100) - 500
                }

                createjs.Tween.get(center_composition).to({ x: x }, 300, createjs.Ease.backOut)

            }

            this._preventSelection = function (b) {
                //stage.preventSelection = b;
            }

            function inViewport(el) {

                var r, html;
                if (!el || 1 !== el.nodeType) {
                    return false;
                }
                html = document.documentElement;
                r = el.getBoundingClientRect();

                return (!!r
                    && r.bottom >= 0
                    && r.right >= 0
                    && r.top <= html.clientHeight
                    && r.left <= html.clientWidth
                );

            }

            function setInview() {

                if (!inViewport(document.getElementById('canvas-editor')))
                    document.getElementById('canvas-editor').scrollIntoView({ behavior: 'smooth', block: 'center' })

            }

            function drawMesure($large, $composition_size, $topText) {

                var con = new createjs.Container();

                var line = new createjs.Shape();
                line.compositeOperation = "source-over";


                line.graphics.setStrokeStyle(4, 'round').beginStroke("#fff");
                line.graphics.moveTo(0, -12);
                line.graphics.lineTo(0, 12);

                line.graphics.setStrokeStyle(4, 'round').beginStroke("#fff").setStrokeDash([], 0);
                line.graphics.moveTo($large, -12);
                line.graphics.lineTo($large, 12);

                line.graphics.setStrokeStyle(4, 'round').beginStroke("#fff").setStrokeDash([10, 10], 0);
                line.graphics.moveTo(0, 0);
                line.graphics.lineTo($large, 0);

                con.addChild(line)

                var text = new createjs.Text(window.tranlsateMesure($composition_size, window.DomainCode), "bold 18px Arial", "#fff");
                text.y = $topText ? 10 : -30;
                text.x = ($large / 2) - (text.getBounds().width / 2)
                con.addChild(text)


                con.cache(-4, -40, $large + 10, 80);


                return con;

            }

            function calculateAmbientSizeFromFrameSize(size, border) {

                var ret = size;
                return ret + ((border * size) / CONSTANTS.CANVAS_WIDTH);

            }

            function getSimultaedAmbient() {

                if ($editorService.ui.showMeasures) {

                    if ($editorService.getLayout().size_group[0] > $editorService.getLayout().size_group[1]) {

                        return {
                            size: calculateAmbientSizeFromFrameSize($editorService.getLayout().size_group[0], 300),
                            center: [510, 500]
                        }

                    } else {

                        return {

                            size: calculateAmbientSizeFromFrameSize($editorService.getLayout().size_group[1], 300),
                            center: [500, 490]
                        }

                    }

                } else {

                    setMeasuresVisibility()


                    if ($editorService.getLayout().size_group[0] > $editorService.getLayout().size_group[1]) {
                        return {

                            size: calculateAmbientSizeFromFrameSize($editorService.getLayout().size_group[0], $editorService.ui.ambientSizeGroupBorder),
                            center: [CONSTANTS.CANVAS_WIDTH / 2, CONSTANTS.CANVAS_HEIGHT / 2]
                        }

                    } else {
                        return {

                            size: calculateAmbientSizeFromFrameSize($editorService.getLayout().size_group[1], $editorService.ui.ambientSizeGroupBorder),
                            center: [CONSTANTS.CANVAS_WIDTH / 2, CONSTANTS.CANVAS_HEIGHT / 2]
                        }

                    }


                }


            }

            function makeMeasures() {


                measuresContainer.removeAllChildren();
                measuresContainer.alpha = 0

                if ($editorService.ui.view.id) {
                    var ambient = $editorService.ui.ambients[$editorService.ui.view.id];
                } else {
                    var ambient = getSimultaedAmbient()
                }


                // lines -------
                var width_composition = $editorService.getLayout().size_group[0];
                var height_composition = $editorService.getLayout().size_group[1];

                if (typeof (ambient) == "undefined") return;

                var large_w = (width_composition * CONSTANTS.CANVAS_WIDTH) / ambient.size
                var lineX = drawMesure(large_w, width_composition, true);
                lineX.x = ambient.center[0] - (large_w / 2)

                measuresContainer.addChild(lineX)

                var large_h = (height_composition * CONSTANTS.CANVAS_HEIGHT) / ambient.size
                var lineY = drawMesure(large_h, height_composition, false);
                lineY.rotation = -90;
                measuresContainer.addChild(lineY);

                lineX.y = ambient.center[1] + (large_h / 2) + 40
                lineY.x = ambient.center[0] - (large_w / 2) - 40
                lineY.y = ambient.center[1] + (large_h / 2)


                // individual numbers
                var sizes_cant = $editorService.getLayout().sizes.length;

                var center_x = ambient.center[0];
                var center_y = ambient.center[1];
                var composition_w = CONSTANTS.CANVAS_WIDTH * _composition_scale;
                var composition_h = CONSTANTS.CANVAS_HEIGHT * _composition_scale;

                for (var i = 0; i < sizes_cant; i++) {

                    var inBound = $editorService.getLayout().bounds[i];
                    var real_x = inBound[0];
                    var real_y = inBound[1];
                    var real_w = inBound[2];
                    var real_h = inBound[3];

                    var _x = center_x + (real_x * _composition_scale) - (composition_w / 2)
                    var _y = center_y + (real_y * _composition_scale) - (composition_h / 2) + ((real_h * _composition_scale) / 2)
                    var _w = real_w * _composition_scale

                    var container_size = new createjs.Container();
                    container_size.x = _x;
                    container_size.y = _y;


                    var text = new createjs.Text(window.tranlsateMesureGroup($editorService.getLayout().sizes[i]), "bold 16px Arial", "#000");
                    text.textAlign = 'center'
                    text.x = _w / 2
                    text.y = -5;
                    var txt_bounds = text.getBounds();

                    var shape = new createjs.Shape();
                    shape.graphics.beginFill("#fff");
                    shape.graphics.drawRoundRect(((_w / 2) - ((txt_bounds.width + 10) / 2)), -10, txt_bounds.width + 10, txt_bounds.height + 10, 5, 5, 5, 5);
                    container_size.addChild(shape)
                    container_size.addChild(text)


                    measuresContainer.addChild(container_size)


                    container_size.cache(((_w / 2) - ((txt_bounds.width + 10) / 2)), -10, txt_bounds.width + 10, txt_bounds.height + 10);

                }

                setMeasuresVisibility()
                createjs.Tween.get(measuresContainer).to({ alpha: 1 }, 500);


            }

            function setShadow($bool) {

                if ($bool) {
                    //back_masks.shadow = new createjs.Shadow("#000000", 0, 1, 10);
                } else {
                    //back_masks.shadow = null;
                }
            }

            function setMeasuresVisibility() {

                if ($editorService.ui.showMeasures) {

                    measuresContainer.visible = true;

                } else {
                    measuresContainer.visible = false;

                }
            }

            function centerComposition(x, y, $cant_cols_in_ambient) {

                if ($editorService.ui.compositionsAsGroup) {

                    if ($editorService.ui.view.id) {

                        var cant_rows = Math.ceil($editorService.data.images.length / $cant_cols_in_ambient);

                        createjs.Tween.get(center_composition).to({
                            x: -((1100 * $cant_cols_in_ambient) / 2),
                            y: -((1100 * cant_rows) / 2)
                        }, 300, createjs.Ease.backOut)


                    } else {

                        var toEditinTileId = $editorService.ui.editingItem;
                        if (toEditinTileId === -1) toEditinTileId = $editorService.data.images.length;
                        createjs.Tween.get(center_composition).to({
                            x: -((1100 * toEditinTileId) + 500),
                            y: -500
                        }, 300, createjs.Ease.backOut)
                    }
                }

                createjs.Tween.get(composition).to({ x: x, y: y }, 300, createjs.Ease.backOut)
            }

            function scaleComposition($factor) {
                _composition_scale = $factor;
                createjs.Tween.get(composition).to({ scale: $factor }, 300, createjs.Ease.backOut)
            }

            function scaleCompositionForAmbient($ambient_width) {


                var width_composition = $editorService.getLayout().size_group[0];
                var height_composition = $editorService.getLayout().size_group[1];

                var factor = width_composition / $ambient_width
                if (height_composition > width_composition) {
                    factor = height_composition / $ambient_width
                }

                scaleComposition(factor)

            }

            function validateViewBorderMask() {
                if (!$editorService.ui.compositionsAsGroup) {
                    if ($editorService.ui.toolOpen === 'images' || $editorService.ui.toolOpen === 'transform' || $editorService.ui.toolOpen === 'filters') {
                        borders_masks.visible = $editorService.ui.view.type === 'edit';
                    } else {
                        borders_masks.visible = false;
                    }
                }
            }

            function setView($type, $id) {

                switch ($type) {

                    case 'edit':

                        setShadow(true)
                        setAmbient(null)

                        transformCopositionForAmbient()

                        break;


                    case 'ambient':

                        setShadow(true)
                        setAmbient($id)

                        break;

                }

                validateViewBorderMask()

            }

            function transformCopositionForAmbient() {

                if ($editorService.ui.view.id) {
                    var ambient = $editorService.ui.ambients[$editorService.ui.view.id];
                } else {
                    var ambient = getSimultaedAmbient()
                }

                if ($editorService.ui.compositionsAsGroup) {
                    if ($editorService.ui.view.id) {
                        // var cant_per_line = 4
                        var cant_rows = 4
                        mozaicTiles(cant_rows)
                    } else {
                        mozaicTiles(false)
                    }
                } else {
                    var cant_rows = false
                }

                centerComposition(ambient.center[0], ambient.center[1], cant_rows);
                scaleCompositionForAmbient(ambient.size);
                makeMeasures();


            }

            function setAmbient($id) {

                if ($id != null) {

                    if (current_ambiend != $id) {
                        var ambient = $editorService.ui.ambients[$id];
                        preloadImagesAmbients.loadFile(FOTOCEDITOR_EDITOR_ASSETS + 'ambients/' + ambient.img);
                    }

                    current_ambiend = $id;

                    if ($editorService.ui.compositionsAsGroup) {
                        center_composition.getChildByName('uploadTile').visible = false;
                    }


                } else {
                    current_ambiend = null;
                    if (ambientsContainer.numChildren > 0) {

                        createjs.Tween.get(ambientsContainer.getChildAt(0)).to({ alpha: 0 }, 300).call(function () {
                            ambientsContainer.removeAllChildren()
                        });
                    }

                    if ($editorService.ui.compositionsAsGroup) {
                        center_composition.getChildByName('uploadTile').visible = true;
                    }


                }

            }

            function addCompositionAssets() {

                center_composition = new createjs.Container();
                composition.addChild(center_composition);

                if ($editorService.ui.compositionsAsGroup) {

                    hit_area_tiles_gorup = new createjs.Shape();
                    hit_area_tiles_gorup.alpha = .01;

                    hit_area_tiles_gorup.graphics.beginFill("#ccc");
                    hit_area_tiles_gorup.name = 'hit'
                    hit_area_tiles_gorup.graphics.drawRect(0, 0, 100, 1200)

                    center_composition.addChild(hit_area_tiles_gorup);

                }

                if (!$editorService.ui.compositionsAsGroup) {
                    back_masks = new createjs.Container();
                    center_composition.addChild(back_masks);

                    for (var i = 0; i < 10; i++) {
                        array_elements_transformables[i] = new com.firsara.display.TransformClip();
                        array_elements_transformables[i].name = i;
                        array_elements_transformables[i].mouseEnabled = false
                        center_composition.addChild(array_elements_transformables[i]);
                    }

                    mask_container = new createjs.Container();
                    mask_container.mouseEnabled = false;
                    mask_container.x = 0;
                    mask_container.y = 0;
                    center_composition.addChild(mask_container);

                    mask_container_group = new createjs.Container();
                    mask_container_group.mouseEnabled = false;
                    mask_container_group.x = 0;
                    mask_container_group.y = 0;
                    center_composition.addChild(mask_container_group);

                    borders_3d_frames = new createjs.Container();
                    borders_3d_frames.mouseEnabled = false;
                    center_composition.addChild(borders_3d_frames);


                    borders_masks = new createjs.Container();
                    borders_masks.mouseEnabled = false;
                    center_composition.addChild(borders_masks);

                    // LOCAL DEV: modo marco -> mat (paspartu) ATRAS de la foto + moldura ADELANTE.
                    // Al estar dentro de center_composition se ven en edicion Y en ambiente.
                    if (window.TYPE_EDITOR === 'marco') {
                        marco_mat = new createjs.Shape();
                        marco_mat.mouseEnabled = false;
                        center_composition.addChildAt(marco_mat, 0);
                        marco_mould = new createjs.Container();
                        marco_mould.mouseEnabled = false;
                        center_composition.addChild(marco_mould);
                    }

                }


                center_composition.x = -CONSTANTS.CANVAS_WIDTH / 2;
                center_composition.y = -CONSTANTS.CANVAS_HEIGHT / 2;

            }

            function updateSliders() {
                if ($editorService.ui.slidersDivs.rotation) {

                    var transformable = getTransformableCurrentEditing();

                    if (transformable === false) return;

                    var r = getTransformableCurrentEditing().rotation;
                    var a = r;

                    if (r > 180 || r < -180) {
                        r = (r % 360)
                        if (r > 180) r = -(360 - r)
                        else if (r < -180) r = (360 + r)
                        getTransformableCurrentEditing().rotation = r
                    }

                    $editorService.ui.slidersDivs.rotation.noUiSlider.set(r)

                }

                if ($editorService.ui.slidersDivs.scale) {
                    $editorService.ui.slidersDivs.scale.noUiSlider.set(getTransformableCurrentEditing().scaleX)
                }
            }

            this.startTick = function () {
                createjs.Ticker.addEventListener("tick", tick);
            }

            this.stopTick = function () {
                try {
                    createjs.Ticker.removeEventListener("tick", tick);
                } catch (e) {
                    console.warn(e);
                }
            }

            function findPosFromTilesName($uuid) {


                var ret = false;
                if ($uuid) {
                    var cant = $editorService.data.images.length;

                    for (var i = 0; i < cant; i++) {
                        if ($editorService.data.images[i].data.uuid === $uuid) return i;
                    }
                }

                return ret;

            }

            function handleCenterComposition_mousedown(e) {

                if ($editorService.ui.view.id) {
                    enable_to_drag = false
                    $editorService.ui.view = { type: 'edit' };
                    return;
                }

                enable_to_drag = true;
                drag_offsetClick = Math.round(e.stageX / composition.scaleX);

                createjs.Tween.removeTweens(center_composition);

                drag_center_composition_last_x = center_composition.x;


                var diference_in_clicks = new Date().getTime() - drag_startTime;

                if (e.nativeEvent && e.nativeEvent.touches) {

                    var uuid = e.target.parent.name;
                    if (uuid === 'transformable') uuid = e.target.parent.parent.name;
                    var get_ClickOverTilePos = findPosFromTilesName(uuid);
                    handleSelectBound(e, get_ClickOverTilePos)
                }


                drag_startTime = new Date().getTime();
            }

            function handleCenterComposition_pressmove(e) {


                if (enable_to_drag) {
                    active_to_click_upload_tiles = false;

                    createjs.Tween.removeTweens(center_composition);

                    if ($editorService.ui.toolOpen != 'transform') {

                        center_composition.x = Math.round(drag_center_composition_last_x + (e.stageX / composition.scaleX) - drag_offsetClick);

                    }

                }


            }

            function handleCenterComposition_pressup(e) {

                e.stopPropagation();
                e.stopImmediatePropagation()

                var new_editingItem = $editorService.ui.editingItem;

                var duration_slide = new Date().getTime() - drag_startTime;
                var displacement = Math.abs(drag_offsetClick - (e.stageX / composition.scaleX))

                var get_ClickOverTilePos = true;

                if (duration_slide < 200 && displacement > 20) {

                    if ($editorService.ui.toolOpen === 'transform') return;


                    if (new_editingItem === -1) {
                        if (drag_offsetClick < (e.stageX / composition.scaleX)) {
                            new_editingItem = $editorService.data.images.length - 1
                        } else {
                            new_editingItem = (Math.abs(Math.round((center_composition.x + 500) / 1100)))
                        }

                    } else {

                        new_editingItem = drag_offsetClick < (e.stageX / composition.scaleX) ? --new_editingItem : ++new_editingItem


                    }

                } else if (duration_slide < 200 && displacement < 20) {

                    if (e.target.parent.name === 'uploadTile') {
                        new_editingItem = 'uploadTile';
                    } else {
                        // como si hiciera click sobre el tiles


                        get_ClickOverTilePos = findPosFromTilesName(e.target.parent.name);
                        if (get_ClickOverTilePos === false) get_ClickOverTilePos = findPosFromTilesName(e.target.parent.parent.name);
                        if (get_ClickOverTilePos !== false) {
                            new_editingItem = get_ClickOverTilePos;
                        }

                        if ($editorService.ui.view.id) {

                            $editorService.ui.view = { type: 'edit' };


                        }

                    }

                } else {

                    new_editingItem = (Math.abs(Math.round((center_composition.x + 500) / 1100)))

                }

                if (new_editingItem < 0) new_editingItem = 0;
                if (new_editingItem === 'uploadTile' || new_editingItem > $editorService.data.images.length - 1) {
                    new_editingItem = -1
                }

                $timeout(function () {

                    $editorService.ui.editingItem = new_editingItem;
                    setInViewEditingFrame();
                }, 0);

                active_to_click_upload_tiles = true

            }

            function handleFileProgressImageAmbient(event) {
                self.isLoading = true;
            }

            function handleFileCompleteImageAmbient(event) {
                self.isLoading = false;
                $rootScope.$apply();

                if (ambientsContainer.numChildren > 0) {

                    createjs.Tween.get(ambientsContainer.getChildAt(0)).to({ alpha: 0 }, 300).call(function () {

                        ambientsContainer.removeChildAt(0);
                        apendAmmbient(event.result)

                    });

                } else {
                    apendAmmbient(event.result)
                }


            }

            function apendAmmbient($image_ambient) {


                switch ($editorService.ui.view.type) {

                    case 'ambient':
                    case 'measure':
                        var image = new createjs.Bitmap($image_ambient);

                        var scale_factor = CONSTANTS.CANVAS_WIDTH / image.image.width;
                        image.scaleX = image.scaleY = scale_factor;
                        image.alpha = 0;
                        image.x = 0;
                        image.y = -((image.image.height * scale_factor) - CONSTANTS.CANVAS_HEIGHT);

                        ambientsContainer.addChildAt(image, 0);
                        createjs.Tween.get(image)
                            .wait(300)
                            .to({ alpha: 1 }, 500);

                        transformCopositionForAmbient()
                        break;
                }
            }

            function showBorderEditingitem() {
                if ($editorService.ui.showBorderEditingitem) {
                    if (!$editorService.getLayout()) return;
                    var bounds_cant = $editorService.getLayout().bounds.length;
                    if (bounds_cant === 0) return;
                    if (borders_masks) {
                        for (var i = 0; i < bounds_cant; i++) {
                            borders_masks.getChildAt(i).visible = false;
                        }
                        if ($editorService.data.group === 0) {
                            borders_masks.getChildAt($editorService.ui.editingItem).visible = true;
                        }
                    }
                }
            }

            function getTransformableCurrentEditing() {
                if ($editorService.ui.compositionsAsGroup) {
                    if ($editorService.ui.editingItem === -1) return false;
                    var tile = center_composition.getChildByName($editorService.data.images[$editorService.ui.editingItem].data.uuid)
                    if (tile) {
                        return tile.getChildByName('transformable');
                    } else {
                        return null
                    }
                } else {
                    return array_elements_transformables[$editorService.ui.editingItem];
                }
            }

            this.isLowResolution = function () {
                var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                return w <= 640;
            }

            this.setManualScaleToEditingTransformable = function ($scale) {
                try {
                    var t = getTransformableCurrentEditing()
                    t.scaleX = t.scaleY = $scale;
                    checkLimits(t, $editorService.ui.editingItem)
                } catch (e) {
                    console.warn(e);
                }
            }

            this.setManualRotateToEditingTransformable = function ($rotation) {
                try {
                    var rotation = $rotation;
                    var t = getTransformableCurrentEditing()

                    t.rotation = rotation;
                    checkLimits(t, $editorService.ui.editingItem)
                } catch (e) {
                    console.warn(e);
                }
            }

            this.changeTypeGroup = function () {
                if ($editorService.data.group === 1) {
                    $editorService.ui.editingItem = 0;
                } else {
                    refillAlEmptyItems();
                }
                applyActiveMask();
                showBorderEditingitem();
                readjustAllImages();
            }

            function refillAlEmptyItems() {
                if ($editorService.data.group === 0) {
                    var cant_boxes = $editorService.getLayout().bounds.length;

                    for (var i = 0; i < cant_boxes; i++) {
                        if (!$editorService.getItemEditing(i).urlWithFilter || !$editorService.getItemEditing(i).userForce) {

                            var clone = Object.assign({}, $editorService.getItemEditing(0));
                            clone.position = {}
                            clone.urlWithFilter = "";
                            clone.userForce = false;

                            $editorService.data.images[i] = clone;

                            self.setImage($editorService.getItemEditing(0).urlWithoutFilter, true, i)
                        }
                    }
                }
            }

            function checkLimits(transformable, inBound) {
                var b;
                if ($editorService.ui.compositionsAsGroup) {
                    b = ($editorService.getLayout().bounds[0]);
                } else {
                    try {
                        if ($editorService.data.group === 1) {
                            b = getBounsdAllMask();
                        } else {
                            b = $editorService.getLayout().bounds[inBound];
                        }
                    } catch (e) {
                        console.warn(e);
                        return;
                    }
                }

                try {
                    var image_bound = transformable.getChildAt(0).getBounds()
                    image_bound.width = image_bound.width * transformable.getChildAt(0).scaleX * transformable.scaleX;
                    image_bound.height = image_bound.height * transformable.getChildAt(0).scaleX * transformable.scaleX;
                } catch (e) {
                    console.warn(e);
                    return;
                }

                if (typeof (b) == "undefined") return;

                var bleeding_in_px = getBleedingInPixeles();

                var sobra_x = (image_bound.width - b[2]) / 2;
                if (sobra_x > 0) {
                    transformable.borders.x = [(b[2] / 2) + b[0] - sobra_x + bleeding_in_px, (b[2] / 2) + b[0] + sobra_x - bleeding_in_px];
                } else {
                    transformable.borders.x = [(b[2] / 2) + b[0] + bleeding_in_px, (b[2] / 2) + b[0] - bleeding_in_px];
                }

                var sobra_y = (image_bound.height - b[3]) / 2;
                if (sobra_y > 0) {
                    transformable.borders.y = [(b[3] / 2) + b[1] - sobra_y + bleeding_in_px, (b[3] / 2) + b[1] + sobra_y - bleeding_in_px];
                } else {
                    transformable.borders.y = [(b[3] / 2) + b[1] + bleeding_in_px, (b[3] / 2) + b[1] - bleeding_in_px];
                }

                if (transformable.x <= transformable.borders.x[0]) transformable.x = transformable.borders.x[0];
                if (transformable.x >= transformable.borders.x[1]) transformable.x = transformable.borders.x[1];
                if (transformable.y <= transformable.borders.y[0]) transformable.y = transformable.borders.y[0];
                if (transformable.y >= transformable.borders.y[1]) transformable.y = transformable.borders.y[1];

            }

            function tick(event) {

                var cant_items = $editorService.data.group === 1 ? 1 : $editorService.data.images.length;

                if ($editorService.ui.compositionsAsGroup) {
                    if ($editorService.data.images[$editorService.ui.editingItem]) {
                        var transformable = getTransformableCurrentEditing();
                        if (!transformable) return;
                        checkLimits(transformable, $editorService.ui.editingItem);
                        var w_px = 0;
                        if (transformable.getChildAt(0)) {
                            w_px = transformable.getChildAt(0).width * transformable.scaleX
                        }
                        var h_px = 0;
                        if (transformable.getChildAt(0)) {
                            h_px = transformable.getChildAt(0).height * transformable.scaleY
                        }

                        $editorService.data.images[$editorService.ui.editingItem].position = {
                            x: transformable.x,
                            y: transformable.y,
                            scaleX: transformable.scaleX,
                            scaleY: transformable.scaleY,
                            rotation: transformable.rotation,
                            width_px: w_px,
                            height_px: h_px,
                            width_cm: convertPixelesToCm(w_px),
                            height_cm: convertPixelesToCm(h_px)
                        }
                    }
                } else {

                    for (var i = 0; i < cant_items; i++) {
                        if ($editorService.data.images[i]) {
                            var transformable = array_elements_transformables[i];
                            checkLimits(transformable, i);

                            var w_px = 0;
                            if (transformable.getChildAt(0)) {
                                w_px = transformable.getChildAt(0).width * transformable.scaleX
                            }
                            var h_px = 0;
                            if (transformable.getChildAt(0)) {
                                h_px = transformable.getChildAt(0).height * transformable.scaleY
                            }

                            $editorService.data.images[i].position = {

                                x: transformable.x,
                                y: transformable.y,
                                scaleX: transformable.scaleX,
                                scaleY: transformable.scaleY,
                                rotation: transformable.rotation,
                                width_px: w_px,
                                height_px: h_px,
                                width_cm: convertPixelesToCm(w_px),
                                height_cm: convertPixelesToCm(h_px)
                            }
                        }
                    }
                }
                //fpsLabel.text = "fps: " + Math.round(createjs.Ticker.getMeasuredFPS(3));
                stage.update(event)
            }

            function applyActiveMask() {

                for (var i = 1; i < array_elements_transformables.length; i++) {
                    array_elements_transformables[i].visible = false;
                }

                if ($editorService.data.group === 1) {
                    var transformableEditing = array_elements_transformables[0];
                    if (mask_container_group) {
                        transformableEditing.mask = mask_container_group.getChildAt(0);
                        resetTransformable(transformableEditing);
                    }
                } else {
                    if ($editorService.getLayout() && mask_container) {
                        var cant_boxes = $editorService.getLayout().bounds.length;
                        for (var i = 0; i < cant_boxes; i++) {
                            array_elements_transformables[i].mask = mask_container.getChildAt(i);
                            //array_elements_transformables[i].alpha = .4
                            if ($editorService.ui.needResetTransformable) {
                                resetTransformable(array_elements_transformables[i], i);
                            }
                            array_elements_transformables[i].visible = true;
                        }
                    }
                }
            }

            function handleSelectBound(e, num) {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()

                if ($editorService.ui.showTools) {
                    if ($editorService.ui.toolOpen === false || $editorService.ui.toolOpen === 'layouts' || $editorService.ui.toolOpen === 'favs') {
                        $editorService.ui.toolOpen = 'images'
                    }
                }

                if (e.nativeEvent && e.nativeEvent.touches && e.nativeEvent.touches.length === 1) {
                    var t = new Date().getTime();
                    if ((t - last_click) < 300 && $editorService.ui.editingItem === num) {
                        if ($editorService.ui.toolOpen === 'transform') {
                            $timeout(function () {
                                $editorService.ui.toolOpen = false
                            }, 400);
                        } else {
                            $editorService.ui.toolOpen = 'transform'
                        }
                    }
                    last_click = new Date().getTime();
                }

                if ($editorService.data.group === 0) {
                    $editorService.ui.editingItem = num;
                }

                $editorService.ui.view = { type: 'edit' };
                $rootScope.$apply();
            }

            function handle_dblclick_frames(e) {
                e.stopPropagation()
                if ($editorService.ui.toolOpen === 'transform') {
                    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    if (w <= 640) {
                        $editorService.ui.toolOpen = false;
                    }
                } else {
                    $editorService.ui.toolOpen = 'transform'
                }

                $rootScope.$apply();
            }

            function handle_back_masks_mousedown(e) {
                var b = $editorService.data.group === 1 ? 0 : e.target.name;
                handleSelectBound(e, b)
            }

            function addListenersInMask() {

                if ($editorService.ui.drawFrame3d) {

                    try {
                        back_masks.removeEventListener("mousedown", handle_back_masks_mousedown)
                        back_masks.removeEventListener("dblclick", handle_dblclick_frames)

                        back_masks.addEventListener("mousedown", handle_back_masks_mousedown);
                        back_masks.addEventListener("dblclick", handle_dblclick_frames);
                    } catch (e) {
                        console.warn(e);
                    }
                }

            }

            function getRatioInPxFromCm($cm) {

                return $editorService.getLayout().size_group[0] > $editorService.getLayout().size_group[1] ? (($cm * 1000) / $editorService.getLayout().size_group[0]) : (($cm * 1000) / $editorService.getLayout().size_group[1])


            }

            function drawMasks() {
                //if ($editorService.ui.drawFrame3d) {

                var bounds = $editorService.getLayout().bounds;

                if (bounds.length === 0) return;

                if (mask_container_group) {
                    mask_container_group.removeAllChildren();
                }

                var shape_group = new createjs.Shape();
                shape_group.alpha = 0;
                shape_group.graphics.beginFill("#ff0000");
                bounds.forEach(function (b) {

                    makeShapePoligonPerimeter(b, shape_group)
                });

                if (mask_container_group) {
                    mask_container_group.addChild(shape_group);
                }

                if (mask_container) {
                    mask_container.removeAllChildren();
                }

                var rel = getRatioInPxFromCm(2) / 2;
                bounds.forEach(function (b) {
                    var shape_group = makeShapePoligonPerimeter(b)
                    shape_group.alpha = 0;
                    if (mask_container) {
                        mask_container.addChild(shape_group);
                    }
                });

                if (borders_masks) {
                    borders_masks.removeAllChildren();
                }

                bounds.forEach(function (b) {
                    var border = new createjs.Shape();
                    border.graphics.beginStroke("red");
                    border.graphics.setStrokeStyle(4);
                    border.snapToPixel = true;
                    border.visible = false;
                    makeShapePoligonPerimeter(b, border);
                    if (borders_masks) {
                        borders_masks.addChild(border);
                    }
                });

                if (back_masks) {
                    back_masks.removeAllChildren();
                }

                bounds.forEach(function (b, index) {

                    var bg = new createjs.Shape();
                    bg.name = index;
                    bg.graphics.beginFill("#000");
                    bg.graphics.drawRect(b[0], b[1], b[2], b[3]);
                    if (back_masks) {
                        back_masks.addChild(bg);
                    }
                });

                if ($editorService.ui.drawFrame3d) {
                    drawFrame3d(null, $editorService.getLayout().frameColor);
                }

                addListenersInMask();
                applyActiveMask();
                showBorderEditingitem()

                // }
            }

            this.updateBorderColor = function ($frameColor, $toAll, $toImage) {


                if ($toAll) {
                    $editorService.data.images.map(function (image) {

                        image.frameColor = $frameColor;
                        var tile = center_composition.getChildByName(image.data.uuid);


                        drawFrame3d(tile.getChildByName('frame'), $frameColor);
                        validateBleeding(tile);

                        return image;

                    });

                } else {
                    var image = getImageEditing();
                    if ($toImage) {
                        image = $toImage;
                    }

                    if (image) {

                        image.frameColor = $frameColor;

                        var tile = center_composition.getChildByName(image.data.uuid);
                        drawFrame3d(tile.getChildByName('frame'), $frameColor);

                        validateBleeding(tile);

                    }


                }


            };

            function validateBleeding($tile) {

                var image = $tile.getChildByName('transformable').getChildAt(0);

                if (image) {

                    var bleeding_in_px = getBleedingInPixeles();

                    adjustImageInBound(image, image.image.width, image.image.height, null, [0, 0, 1000, 1000]);

                }

            }

            function getGradienteFrame(pos, $color) {


                switch ($color) {


                    case '':
                    case undefined:
                    case 'NONE':
                        return $editorService.ui.gradientFrameColors[pos];
                    default:
                        if (pos === 0) return [$color, $color];
                        if (pos === 1) return [$color, $color];
                        break;


                }

            }


            function makeShapePoligonPerimeter($bound, toShape) {

                var rel = getRatioInPxFromCm(2) / 2;
                var shape = new createjs.Shape();
                if (angular.isDefined(toShape)) {
                    shape = toShape;
                } else {
                    shape.graphics.beginFill("#333");
                }

                if (!$editorService.ui.drawFrame3d) {
                    //cuadrado
                    shape.graphics
                        .moveTo($bound[0], $bound[1])
                        .lineTo($bound[0] + $bound[2], $bound[1])
                        .lineTo($bound[0] + $bound[2], $bound[1] + $bound[3])
                        .lineTo($bound[0], $bound[1] + $bound[3])
                        .lineTo($bound[0], $bound[1])
                } else {
                    //3d
                    shape.graphics
                        .moveTo($bound[0], $bound[1])
                        .lineTo($bound[0] + $bound[2], $bound[1])
                        .lineTo($bound[0] + $bound[2] + rel, $bound[1] + rel + (rel / 2))
                        .lineTo($bound[0] + $bound[2] + rel, $bound[1] + $bound[3] + rel)
                        .lineTo($bound[0] + rel + (rel / 2), $bound[1] + $bound[3] + rel)
                        .lineTo($bound[0], $bound[1] + $bound[3])
                }

                return shape;
            }

            // $holder solo apica para los tiles
            function drawFrame3d($holder, $color) {

                var bounds = $editorService.getLayout().bounds;

                if (bounds.length === 0) return;

                var rel = getRatioInPxFromCm(2) / 2;

                if ($holder) {
                    $holder.removeChild($holder.getChildByName('shape3D'))
                    $holder.removeChild($holder.getChildByName('shape3D2'))
                } else {
                    if (borders_3d_frames) {
                        borders_3d_frames.removeAllChildren();
                    }

                }

                var withColor = false;

                if ($color) {
                    withColor = true;
                }


                bounds.forEach(function (b) {

                    var shape_group = new createjs.Shape();
                    shape_group.name = 'shape3D';
                    shape_group.alpha = 1;

                    shape_group.graphics.beginLinearGradientFill(getGradienteFrame(0, $color), (withColor ? [0, 1] : [0, 1]), b[0] + b[2], 0, b[0] + b[2] + rel + rel, 0)
                    shape_group.graphics
                        .moveTo(b[0] + b[2], b[1])
                        .lineTo(b[0] + b[2] + rel, b[1] + rel + (rel / 2))
                        .lineTo(b[0] + b[2] + rel, b[1] + b[3] + rel)
                        .lineTo(b[0] + b[2], b[1] + b[3])


                    var stroke0 = new createjs.Shape();
                    stroke0.graphics.beginLinearGradientStroke(["#FFFFFF00", "#FFF"], [0, 1], 0, b[1], 0, b[1] + b[3])
                    stroke0.graphics
                        .moveTo(b[0] + b[2], b[1])
                        .lineTo(b[0] + b[2], b[1] + b[3])

                    var shape_group2 = new createjs.Shape();
                    shape_group2.name = 'shape3D2';
                    shape_group2.alpha = 1;

                    shape_group2.graphics.beginLinearGradientFill(getGradienteFrame(1, $color), (withColor ? [0, 1] : [0, 1]), 0, b[1] + b[3], 0, b[1] + b[3] + rel + rel)
                    shape_group2.graphics
                        .moveTo(b[0] + b[2] + rel, b[1] + b[3] + rel)
                        .lineTo(b[0] + rel + (rel / 2), b[1] + b[3] + rel)
                        .lineTo(b[0], b[1] + b[3])
                        .lineTo(b[0] + b[2], b[1] + b[3])

                    var stroke1 = new createjs.Shape();
                    stroke1.graphics.beginLinearGradientStroke(["#FFFFFF00", "#FFFFFF"], [0, 1], b[0], 0, b[0] + b[2], 0)
                    stroke1.graphics
                        .moveTo(b[0], b[1] + b[3])
                        .lineTo(b[0] + b[2], b[1] + b[3])

                    if ($holder) {
                        $holder.addChild(shape_group);
                        $holder.addChild(shape_group2);
                        if (!$editorService.ui.compositionsAsGroup) {
                            $holder.addChild(stroke0);
                            $holder.addChild(stroke1);
                        }
                    } else {
                        if (!$editorService.ui.compositionsAsGroup) {
                            borders_3d_frames.addChild(shape_group);
                            borders_3d_frames.addChild(shape_group2);
                            borders_3d_frames.addChild(stroke0);
                            borders_3d_frames.addChild(stroke1);
                        }
                    }

                });


            }

            // LOCAL DEV: dibuja el passepartout (mat blanco) + la moldura del modo marco
            // dentro de center_composition (se ve en edicion Y en ambiente; las medidas quedan
            // por encima). Todo en el bound de la foto expandido. Unidades = espacio 1000.
            function drawMarcoFrame() {
                if (window.TYPE_EDITOR !== 'marco' || !marco_mat || !marco_mould) return;
                var bounds = $editorService.getLayout().bounds;
                if (!bounds || !bounds.length) return;
                var b = bounds[0];
                var cfg = ($editorService.ui.config && $editorService.ui.config.marco) || {};
                var MAT = cfg.mat != null ? cfg.mat : 52;
                var MOULD = cfg.mould != null ? cfg.mould : 44;
                var color = marco_frame_color || cfg.color || '#1a1a1a';

                var mx = b[0] - MAT, my = b[1] - MAT, mw = b[2] + 2 * MAT, mh = b[3] + 2 * MAT;
                marco_mat.graphics.clear().beginFill('#ffffff').drawRect(mx, my, mw, mh);

                marco_mould.removeAllChildren();
                var ox = mx - MOULD, oy = my - MOULD, ow = mw + 2 * MOULD, oh = mh + 2 * MOULD;
                var ring = new createjs.Shape();
                ring.graphics.beginFill(color)
                    .drawRect(ox, oy, ow, MOULD)
                    .drawRect(ox, oy + oh - MOULD, ow, MOULD)
                    .drawRect(ox, oy, MOULD, oh)
                    .drawRect(ox + ow - MOULD, oy, MOULD, oh);
                marco_mould.addChild(ring);
                var bevel = new createjs.Shape();
                bevel.graphics.setStrokeStyle(2).beginStroke('rgba(255,255,255,.18)').drawRect(mx, my, mw, mh);
                marco_mould.addChild(bevel);
            }

            this.setMarcoFrame = function ($color) {
                marco_frame_color = $color;
                drawMarcoFrame();
                if (stage) stage.update();
            };

            this.setLayout = function ($refillEmptyItems) {

                if (typeof ($refillEmptyItems) == "undefined") {
                    $refillEmptyItems = true;
                }

                if ($editorService.getLayout().bounds.length === 0) return;

                drawMasks();
                drawMarcoFrame();

                if ($refillEmptyItems) refillAlEmptyItems();

                if ($editorService.ui.useShutterStockGallery) {
                    readjustAllImages();
                }

                makeMeasures();

            }

            this.makeFromData = function ($resetTransformale) {
                if (!$editorService.ui.compositionsAsGroup) {
                    $resetTransformale = $resetTransformale || false;

                    this.setLayout(false);

                    var cant_images = $editorService.data.images.length;

                    for (var i = 0; i < 10; i++) {
                        array_elements_transformables[i].removeChildAt(0)
                    }

                    for (var i = 0; i < cant_images; i++) {

                        if ($editorService.data.images[i]) {

                            self.setImage($editorService.data.images[i].urlWithFilter, $resetTransformale, i, false);

                            array_elements_transformables[i].x = $editorService.data.images[i].position.x;
                            array_elements_transformables[i].y = $editorService.data.images[i].position.y;
                            array_elements_transformables[i].scaleX = $editorService.data.images[i].position.scaleX;
                            array_elements_transformables[i].scaleY = $editorService.data.images[i].position.scaleY;
                            array_elements_transformables[i].rotation = $editorService.data.images[i].position.rotation;

                        }
                    }
                }
            }

            function getTile($uuid) {
                return center_composition.getChildByName($uuid)
            }

            this.getTile = function ($uuid) {
                return getTile($uuid)
            }

            function getTileEditing() {
                return getTile($editorService.data.images[$editorService.ui.editingItem].data.uuid)
            }

            function getImageEditing() {
                return $editorService.data.images[$editorService.ui.editingItem];
            }

            this.getImageEditing = function () {
                return getImageEditing();
            }

            this.getShareSnapshoot = function ($isScale) {

                return this.getSnapshot(true);

            }

            this.getSnapshotTile = function ($tilePos) {
                var tile = getTile($editorService.data.images[$tilePos].data.uuid);
                tile.cache(0, 0, 1100, 1100);
                var ret = tile.cacheCanvas.toDataURL();
                tile.uncache();
                return ret;
            };

            this.closeTutorial = function () {
                $tutorialService.close();
            };

            this.getSnapshot = function ($isScale) {

                if ($editorService.ui.drawFrame3d && borders_masks) {
                    borders_masks.visible = false;
                }

                setShadow(false);
                if ($isScale) {


                    if (!$editorService.ui.compositionsAsGroup) {
                        center_composition.scaleX = .5;
                        center_composition.scaleY = .5;
                        composition.cache(-500, -500, 500, 500);
                        var ret = composition.cacheCanvas.toDataURL();
                        center_composition.scaleX = 1;
                        center_composition.scaleY = 1;
                        composition.uncache()

                    } else {
                        try {
                            var tile = getTileEditing();
                            tile.cache(0, 0, 1100, 1100);
                            var ret = tile.cacheCanvas.toDataURL();
                            tile.uncache();
                        } catch (e) {
                            console.warn(e);
                            var tile = getTile($editorService.data.images[0].data.uuid);
                            tile.cache(0, 0, 1100, 1100);
                            var ret = tile.cacheCanvas.toDataURL();
                            tile.uncache();
                        }
                    }

                } else {
                    if (!$editorService.ui.compositionsAsGroup) {
                        center_composition.cache(0, 0, 1000, 1000);
                        var ret = center_composition.cacheCanvas.toDataURL();
                        center_composition.uncache()
                    } else {
                        try {
                            var tile = getTileEditing();
                            tile.cache(0, 0, 1100, 1100);
                            var ret = tile.cacheCanvas.toDataURL();
                            tile.uncache();
                        } catch (e) {
                            console.warn(e);
                            var tile = getTile($editorService.data.images[0].data.uuid);
                            tile.cache(0, 0, 1100, 1100);
                            var ret = tile.cacheCanvas.toDataURL();
                            tile.uncache();
                        }
                    }
                }
                setShadow(true)
                validateViewBorderMask()
                return ret;
            }

            function resetTransformable($transformableEditing, box) {

                if ($editorService.data.group === 1) {
                    $transformableEditing.rotation = 0
                    $transformableEditing.x = CONSTANTS.CANVAS_WIDTH / 2;
                    $transformableEditing.y = CONSTANTS.CANVAS_WIDTH / 2;
                    $transformableEditing.scaleX = 1;
                    $transformableEditing.scaleY = 1;
                    $transformableEditing.borders.scale = [1, 3];

                } else {
                    var b = $editorService.getLayout().bounds[box];
                    if (typeof (b) == 'undefined') return;
                    $transformableEditing.rotation = 0
                    $transformableEditing.x = b[0] + (b[2] / 2);
                    $transformableEditing.y = b[1] + (b[3] / 2);
                    $transformableEditing.scaleX = 1;
                    $transformableEditing.scaleY = 1;
                    $transformableEditing.borders.scale = [1, 3];

                }

                try {
                    updateSliders();
                } catch (e) {
                    console.warn(e);
                }

            }

            this.refreshPositionEditingItem = function () {
                if (!$editorService.ui.compositionsAsGroup) {
                    resetTransformable(array_elements_transformables[$editorService.ui.editingItem], $editorService.ui.editingItem)
                } else {
                    var transformable = center_composition.getChildByName($editorService.data.images[$editorService.ui.editingItem].data.uuid).getChildByName('transformable')
                    resetTransformable(transformable, 0)
                }
            }

            function handleFileProgressImageTile(event) {
                self.isLoading = true;
                $timeout(function () {
                    $rootScope.$apply();
                })
            }

            function handleFileProgressImage(event) {
                if (!$editorService.ui.compositionsAsGroup) {
                    self.isLoading = true;
                    $timeout(function () {
                        $rootScope.$apply();
                    })
                }
            }

            function handleFileCompleteImage(event) {

                var image = new createjs.Bitmap(event.result);
                image.tickEnabled = false;

                var trasform_bitmap = adjustImageInBound(image, image.image.width, image.image.height, event.item.inHolder)
                if (!$editorService.ui.compositionsAsGroup) {
                    var transformableEditing = array_elements_transformables[event.item.inHolder];
                    try {
                        transformableEditing.removeChildAt(1)
                        transformableEditing.removeChildAt(0)
                        transformableEditing.addChildAt(image, 0);

                    } catch (e) {
                        console.warn(e);
                    }



                    if (event.item.resetTransformale) {
                        resetTransformable(transformableEditing, event.item.inHolder);
                    }

                }
                self.isLoading = false;
                $rootScope.$apply();

            }

            this.setImageWithFilter = function ($url, $resetTransformale, $inHolder) {

                if (!$editorService.ui.compositionsAsGroup) {
                    this.setImage($url, $resetTransformale, $inHolder)
                } else {
                    if (angular.isUndefined($inHolder)) {
                        $inHolder = $editorService.ui.editingItem;
                    }
                    var tile = center_composition.getChildByName($editorService.data.images[$inHolder].data.uuid)
                    $editorService.getItemEditing($inHolder).urlWithFilter = $url;
                    loadImageOnTile(tile, $url, $inHolder);
                }
            }

            this.setImage = function ($url, $resetTransformale, $inHolder, $refillOthers, $proxyUploadCare, $crop, $resize) {

                if (!$editorService.ui.compositionsAsGroup) {
                    if (typeof ($resetTransformale) == "undefined") {
                        $resetTransformale = true;
                    }
                    if (typeof ($refillOthers) == "undefined") {
                        $refillOthers = true;
                    }
                    try {
                        clearTimeout($editorService.ui.intervalSubmission[$inHolder]);
                    } catch (e) {
                        console.warn(e);
                    }
                    self.isLoading = true;
                    if (typeof ($inHolder) == "undefined") {
                        $inHolder = $editorService.ui.editingItem;
                    }
                    $editorService.getItemEditing($inHolder).urlWithFilter = $url;

                    var preloadImages = new createjs.LoadQueue(true, "", true);
                    preloadImages.addEventListener("fileload", handleFileCompleteImage);
                    preloadImages.addEventListener("progress", handleFileProgressImage);
                    preloadImages.addEventListener("fileprogress", handleFileProgressImage);



                    var $src = $proxyUploadCare ?
                        $editorService.getProxyUploadCare($url, $crop, $resize) :
                        $editorService.getProxyImageUrl($url, $crop, $resize);

                    preloadImages.loadFile({
                        src: $src,
                        type: createjs.Types.IMAGE,
                        'resetTransformale': $resetTransformale,
                        'inHolder': $inHolder,
                        'refillOthers': $refillOthers
                    });
                }
            };

            function readjustAllImages() {
                if (!$editorService.getLayout()) return;
                var cant_images = $editorService.getLayout().bounds.length;
                for (var i = 0; i < cant_images; i++) {
                    if ($editorService.data.images[i]) {
                        var bitmap = array_elements_transformables[i].getChildAt(0);
                        if (typeof bitmap != 'undefined') {
                            adjustImageInBound(bitmap, bitmap.image.width, bitmap.image.height, i)
                        }
                    }
                }
            }

            function convertPixelesToCm($px) {
                var width_composition = $editorService.getLayout().size_group[0];
                var height_composition = $editorService.getLayout().size_group[1];
                if (width_composition > height_composition) {
                    return ($px * width_composition) / CONSTANTS.CANVAS_WIDTH;
                } else {
                    return ($px * height_composition) / CONSTANTS.CANVAS_HEIGHT;
                }
            }

            function getBleedingInPixeles() {
                var _constW = CONSTANTS.CANVAS_WIDTH;
                var _constH = CONSTANTS.CANVAS_WIDTH;
                var layout = $editorService.getLayout();
                var bleeding = $editorService.ui.config.bleeding;

                if (getImageEditing()) {
                    if (angular.isDefined(getImageEditing().frameColor) && getImageEditing().frameColor != 'NONE') {
                        bleeding = 0;
                    }
                }

                if (layout.size_group[0] > layout.size_group[1]) {
                    return (bleeding * _constW) / layout.size_group[0];
                } else {
                    return (bleeding * _constH) / layout.size_group[1];
                }
            }

            function adjustImageInBound(image, $src_w, $src_h, $holder, _bounds) {
                var layout = $editorService.getLayout();
                if (!layout) return;
                if (!bounds) {
                    // ???
                }
                var bounds = _bounds || layout.bounds[$holder]
                if (bounds) {
                    if ($editorService.data.group === 1) {
                        bounds = getBounsdAllMask()
                    }
                    var bleeding_in_px = getBleedingInPixeles()
                    var ratio = 1;
                    if (($src_w / $src_h) > (bounds[2] / bounds[3])) {
                        $resize_h = bounds[3] + (bleeding_in_px * 2);
                        $resize_w = $src_w * $resize_h / $src_h;
                        ratio = $resize_h / $src_h;
                    } else {
                        $resize_w = bounds[2] + (bleeding_in_px * 2);
                        $resize_h = $src_h * $resize_w / $src_w;
                        ratio = $resize_w / $src_w;
                    }

                    image.scaleX = image.scaleY = ratio;
                    image.x = -$resize_w / 2;
                    image.y = -$resize_h / 2;
                    image.width = $resize_w;
                    image.height = $resize_h;
                    return { w: $resize_w, h: $resize_h, 'x': image.x, 'y': image.y, 'scale': ratio };

                } else {
                    return { w: $src_w, h: $src_h, 'x': 0, 'y': 0, 'scale': 1 };
                }
            }

            function getBounsdAllMask() {

                var x = 500;
                var y = 500;
                var w = 0;
                var h = 0;

                var bounds = $editorService.getLayout().bounds;
                bounds.forEach(function (b) {
                    if (b[0] < x) x = b[0];
                    if (b[1] < y) y = b[1];
                    if ((b[0] + b[2]) > w) w = (b[0] + b[2]);
                    if ((b[1] + b[3]) > h) h = (b[1] + b[3]);
                })

                return [x, y, (w - x), (h - y)];
            }

        }])
})();